import { useLang } from '@/app/utils/useLang';
import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import { FC, useState } from 'react';
import { IconPoint } from '../Svg';
import styled from './index.module.scss';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/getLocal';

interface IProps {
    deatil?: any;
}

const linkMap = {};

const Panoramic: FC<IProps> = ({}) => {
    const { t } = useLang('theProduct.pathtozero');
    const { locale } = getLocal();
    const [active, setActive] = useState('');

    const handleChangeActive = (type: string, button_name: string, tab: string) => {
        gtm.push({ event: 'uaEvent', event_name: 'product_details', tab, button_name });
        if (type === active) {
            setActive('');
        } else {
            setActive(type);
        }
    };

    const pointList = [
        {
            iconText: t('pathtozero_starter'),
            key: 'a',
            detailTitle: t('pathtozero_starter_title'),
            detailDesc: t('pathtozero_starter_desc'),
            link: `https://${locale}.ecoflow.com/products/stream-balcony-solar-system`,
        },
        {
            iconText: t('pathtozero_ultra'),
            key: 'b',
            detailTitle: t('pathtozero_ultra_title'),
            detailDesc: t('pathtozero_ultra_desc'),
            link: `https://${locale}.ecoflow.com/products/stream-ultra-pro`,
        },
        {
            iconText: t('pathtozero_ac'),
            key: 'c',
            detailTitle: t('pathtozero_ac_title'),
            detailDesc: t('pathtozero_ac_desc'),
            link: `https://${locale}.ecoflow.com/products/stream-ac-pro-ac`,
        },
    ];

    return (
        <div className={styled.Panoramic}>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1745899216468/steam0.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1745899216468/steam0.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1745478273794/steam2-m.jpg"
            />
            <p className="panoramic-title">{t('pathtozero_title')}</p>
            <ul className="point-list">
                {pointList.map((item) => (
                    <li
                        key={item.key}
                        className={`point-item point${item.key} ${active === item.key ? 'hidden' : ''}`}
                        onClick={() => handleChangeActive(item.key, item.iconText, item.detailTitle)}
                    >
                        <div className="point-svg">
                            <span>{item.iconText}</span>
                            <div className="svg-box">
                                <IconPoint />
                            </div>
                        </div>

                        <div className={`detail detail-${item.key} ${active === item.key ? 'show' : ''}`} onClick={(event) => event.stopPropagation()}>
                            <p className="detail-title">{item.detailTitle}</p>
                            <p className="detail-desc">{item.detailDesc}</p>
                            <EfLink
                                href={item.link}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'buy',
                                    product_name: item.detailTitle,
                                    position: `Flash Sale_${item.detailTitle}_Pop-up_${t('pathtozero_learnmore')}`,
                                }}
                                target="_blank"
                            >
                                {t('pathtozero_learnmore')}
                            </EfLink>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Panoramic;
